import BaseModelPartner from "@/models/BaseModelPartner.js";

export const GridConfig = {
	list: BaseModelPartner.list,
	columns: BaseModelPartner.columns,
	grid: {		
		gridId:'partnerGrid',
		checkbox: true,
		edit: true,
		delete: false,		
		document: true,
		height: 500,
		pageSize: 100,
		groupable: true,
	}
}

export const ToolbarConfig = {
	items: [       
			{
				id:"btnAddPartner",
				type: "button",
				text: "Add Partner",
				showIcon: "toolbar",
				icon:"plus-circle",
				attributes: { "class": "btn btn-primary float-right-btn" }
			},
			{
                id:"btnBulkImportPartner",
                type: "button",
                text: "Bulk Import",
                showIcon: "toolbar",
                icon:"upload",
                attributes: { "class": "float-right-btn btn btn-secondary" },
			}
	]
}